import { X } from 'lucide-react';

import { useTranslation } from 'react-i18next';

interface MetadataEditorProps {
  value: Record<string, string>;
  onChange: (v: Record<string, string>) => void;
}

export function MetadataEditor({ value, onChange }: MetadataEditorProps) {
  const { t } = useTranslation('pleri/skills');
  const entries = Object.entries(value).filter(([k]) => !k.startsWith('_'));

  const addRow = () => onChange({ ...value, '': '' });
  const removeRow = (key: string) => {
    const copy = { ...value };
    delete copy[key];
    onChange(copy);
  };
  const updateKey = (oldKey: string, newKey: string) => {
    const copy: Record<string, string> = {};
    for (const [k, v] of Object.entries(value)) {
      copy[k === oldKey ? newKey : k] = v;
    }
    onChange(copy);
  };
  const updateValue = (key: string, newValue: string) => {
    onChange({ ...value, [key]: newValue });
  };

  return (
    <div className="space-y-2">
      {entries.map(([key, val], i) => (
        <div key={i} className="flex items-center gap-2">
          <input
            className="w-1/3 rounded-md border border-gray-300 px-2 py-1 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            placeholder={t('key')}
            value={key}
            onChange={(e) => updateKey(key, e.target.value)}
          />
          <input
            className="flex-1 rounded-md border border-gray-300 px-2 py-1 text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100"
            placeholder={t('value')}
            value={val}
            onChange={(e) => updateValue(key, e.target.value)}
          />
          <button
            onClick={() => removeRow(key)}
            className="rounded p-1 text-gray-400 hover:text-red-500"
            type="button"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
      <button
        onClick={addRow}
        type="button"
        className="text-xs text-orange-600 hover:text-orange-700"
      >
        {t('addMetadata')}
      </button>
    </div>
  );
}
